import getColor from "@insite/mobius/utilities/getColor";
import { userInformationStyles } from "@waytek/Overrides/Widgets/AccountSettings/AccountSettingsUserInformation";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

userInformationStyles.userInformationWrapper = {
    ...userInformationStyles.userInformationWrapper,
    css: css`
        ${mediaQueriesBP.minMD} {
            padding-right: 20px;
        }
    `,
};

userInformationStyles.userInformationInnerWrapper = {
    ...userInformationStyles.userInformationInnerWrapper,
    css: css`
        ${mediaQueriesBP.minLG} {
            padding-right: 60px;
        }
    `,
};

userInformationStyles.userInformationTitle = {
    ...userInformationStyles.userInformationTitle,
    variant: "h6",
    as: "h2",
    css: css`
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.78;
        letter-spacing: normal;
        border-bottom: 3px solid ${getColor("common.global.industrialTaupe")};
        margin-bottom: 20px;
    `,
};

userInformationStyles.changePasswordLink = {
    ...userInformationStyles.changePasswordLink,
    css: css`
        &&& {
            font-weight: normal;
            margin-left: 10px;
        }
    `,
};
